<template>
  <el-dialog
    title="Linked Accounts"
    top="5vh"
    visible
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <h1>Accounts</h1>
    <p>The following table listed linked accounts with this rate surcharge</p>
    <el-table
      v-loading="isLoading"
      :data="linkedAccounts"
      stripe
    >
      <el-table-column
        label="Account Name"
        prop="account"
        :formatter="row => $_.get(row, 'account.name', '-')"
      />
      <el-table-column
        label="Start Date"
        prop="date_start"
        :formatter="row => formatDate($_.get(row, 'date_start', 'Unknown'))"
      />
      <el-table-column
        label="End Date"
        prop="date_end"
        :formatter="row => formatDate($_.get(row, 'date_end', 'Unknown'))"
      />
      <el-table-column
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click.native="deleteLinkedAccount(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[5, 10, 20, 50]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <hr>
    <h1>Attach Account</h1>
    <p>Attach account with this rate surcharge</p>
    <el-form
      ref="indexModelForm"
      v-loading="isSaving"
      :rules="rules"
      :model="indexModel"
    >
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Start Date"
            prop="date_start"
          >
            <el-date-picker
              v-model="indexModel.date_start"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              placeholder="Pick a Start Date"
              :picker-options="datePickerOption"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="End Date"
            prop="date_end"
          >
            <el-date-picker
              v-model="indexModel.date_end"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              placeholder="Pick a End Date"
              :picker-options="datePickerOption"
              class="w-100"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Account"
            prop="account"
          >
            <el-select
              v-model="indexModel.account"
              filterable
              remote
              value-key="id"
              placeholder="Enter name of account"
              class="w-100"
              :remote-method="remoteMethodAccount"
              :loading="isLoadingAccounts"
            >
              <el-option
                v-for="item in accounts"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="attachAccount"
      >
        Attach
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    group: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      linkedAccounts: [],
      indexModel: null,
      isFullscreen: false,
      page: 1,
      perPage: 5,
      total: 0,
      isLoading: false,
      isLoadingAccounts: false,
      accounts: [],
      isSaving: false,
      datePickerOption: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'A week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      rules: {
        account: [
          { required: true, message: 'Account is required', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadTable()
    this.indexModel = new this.$sdk.ratesurcharge_index()
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.ratesurcharge_index.list(builder => {
        builder.filters = { rate_surcharge_index_group: this.group.id }
        builder.include = ['account', 'group']
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'name:asc'
      })
        .then(res => {
          this.linkedAccounts = res
          this.linkedAccounts.map(a => {
            a.date_start = a.date_start === 'Invalid date' ? undefined : a.date_start
          })
          this.total = res.total
        })
        .finally(() => { this.isLoading = false })
    },
    attachAccount () {
      this.$refs.indexModelForm.validate((valid) => {
        if (valid) {
          if (!this.group) {
            this.$message({ message: 'This rate surcharge does not have a group', type: 'error' })
            return
          }
          this.isSaving = true
          this.indexModel.group = this.group
          if (this.indexModel.date_start) this.indexModel.date_start = this.$moment(this.indexModel.date_start).format('YYYY-MM-DD 00:00:00')
          if (this.indexModel.date_end) this.indexModel.date_end = this.$moment(this.indexModel.date_end).format('YYYY-MM-DD 00:00:00')
          this.indexModel.create()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.indexModel = new this.$sdk.ratesurcharge_index()
              this.$refs.indexModelForm.resetFields()
              this.loadTable()
            })
        }
      })
    },
    deleteLinkedAccount (index, row) {
      this.$confirm('Are you sure to delete this?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete()
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    },
    remoteMethodAccount (query) {
      this.isLoadingAccounts = true
      this.$sdk.account.list(builder => {
        builder.filters = { account_name: query, account_active: 1 }
      }).then(res => {
        this.accounts = res
      }).finally(() => { this.isLoadingAccounts = false })
    },
    formatDate (date) {
      if (date !== 'Unknown' && date !== null) {
        return this.$moment(date).format('YYYY-MM-DD')
      } else {
        return 'Unknown'
      }
    }
  }
}
</script>

<style>

</style>
